import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  const quotes = [
    {
      text: "L'informatique est la science de la manipulation automatique de l'information.",
      author: "Claude Shannon",
    },
    {
      text: "Les machines sont de plus en plus intelligentes, mais elles resteront toujours des outils.",
      author: "Alan Turing",
    },
    {
      text: "La programmation est un art, et les programmeurs sont les artistes.",
      author: "John Carmack",
    },
  ];

  return (
    <section
      id="carousel"
      className="relative min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: 'url("images/accueil.avif")',
      }}
    >
      <div className="flex items-center justify-center min-h-screen bg-black bg-opacity-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8 text-center">
            Citations Inspirantes
          </h2>
          <Slider {...settings} className="relative w-full max-w-3xl mx-auto">
            {quotes.map((quote, index) => (
              <div
                key={index}
                className="p-4 sm:p-6 bg-white shadow-lg rounded-lg text-center"
                style={{ minHeight: "150px", maxHeight: "250px" }}
              >
                <p className="text-sm sm:text-lg italic text-gray-600 mb-4">
                  "{quote.text}"
                </p>
                <p className="text-xs sm:text-md font-semibold text-gray-800">
                  — {quote.author}
                </p>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Carousel;
